export default __webpack_public_path__ + "static/media/dark_pink.46e449f3.png";